<div class="background">
    <router-outlet></router-outlet>
</div>